import React from "react"
import strings from "../../localization/strings"
import { Dialog, FlatButton, Table, TableHeader, TableRow, TableHeaderColumn, TableBody, TableRowColumn } from "material-ui"
import { ETimecardSequenceActionType, IPaySettings, ITimecardSequenceWarningData } from "../../models"
import { grey600 } from "material-ui/styles/colors"
import * as timecardHelper from "../../helpers/timecardHelper"
import * as timeHelper from "../../helpers/timeHelper"
import AccountStore from "../../stores/AccountStore"
interface IProps {
	selectedPaySettings?: IPaySettings
	warningData: ITimecardSequenceWarningData
	handleClose(): void
	handleRetry?(): void
}

const TimecardSequenceWarningDialog: React.SFC<IProps> = (props: IProps) => {
	let title
	let content
	switch (props.warningData.Type) {
		case ETimecardSequenceActionType.GetPayroll:
			title = strings.Warning
			content = strings.formatString(strings.Payroll_Time_Get_Warning, props.warningData.WarningItems.length)
			break
		case ETimecardSequenceActionType.LockPayroll:
			title = strings.Cannot_Lock_Payroll
			content = strings.formatString(strings.Payroll_Time_Lock_Warning, props.warningData.WarningItems.length)
			break
		case ETimecardSequenceActionType.EmployeeLockPayroll:
			title = strings.Cannot_Employee_Lock_Payroll
			content = strings.formatString(strings.Payroll_Time_Employee_Lock_Warning, props.warningData.WarningItems.length)
			break
		case ETimecardSequenceActionType.ApprovePunchSetTimecard:
			title = strings.Cannot_Approve_Timecard
			content = strings.formatString(strings.x_TimecardSequence_locked_warning, props.warningData.WarningItems.length)
			break
		case ETimecardSequenceActionType.UnapprovePunchSetTimecard:
			title = strings.Cannot_UnApprove_Timecard
			content = strings.formatString(strings.x_TimecardSequence_locked_warning, props.warningData.WarningItems.length)
			break
		case ETimecardSequenceActionType.ReviewLocException:
			title = strings.Cannot_Review_Location_Exception
			content = strings.TimecardSequence_locked_warning
			break
		case ETimecardSequenceActionType.ReviewBioException:
			title = strings.Cannot_Review_Biometric_Exception
			content = strings.TimecardSequence_locked_warning
			break
		case ETimecardSequenceActionType.ExportToThirdParty:
			title = strings.Warning
			content = strings.ExportToThirdParty_locked_warning
			break
		case ETimecardSequenceActionType.RecalculateTimecard:
			title = strings.Cannot_Recalculate_Timecard
			content = strings.TimecardSequence_locked_warning
			break
	}
	return (
		<Dialog
			open
			autoScrollBodyContent
			title={title}
			actions={props.warningData.Type === ETimecardSequenceActionType.GetPayroll || AccountStore.getPayrollLambdaEnabled() ?
				<FlatButton label={strings.OK} primary onClick={props.handleClose} /> : [
					<FlatButton label={strings.Cancel} secondary onClick={props.handleClose} />,
					<FlatButton label={strings.Retry} primary
						onClick={() => {
							props.handleClose()
							props.handleRetry && props.handleRetry()
						}}
					/>
				]}
		>
			<div style={{ marginTop: 20, color: grey600 }}>
				{content}
			</div>
			{props.warningData.WarningItems && props.warningData.WarningItems.length > 0 &&
				<Table selectable={false}>
					<TableHeader
						displaySelectAll={false}
						adjustForCheckbox={false}
						enableSelectAll={false}
					>
						<TableRow style={{ height: 40 }}>
							<TableHeaderColumn style={styles.nameCol}>{strings.Name}</TableHeaderColumn>
							<TableHeaderColumn style={styles.idCol}>{strings.Employee_ID}</TableHeaderColumn>
							{props.warningData.Type === ETimecardSequenceActionType.GetPayroll &&
								<TableHeaderColumn>{strings.Timecard_Dates}</TableHeaderColumn>
							}
							<TableHeaderColumn style={styles.statusCol}>{strings.Status}</TableHeaderColumn>
							<TableHeaderColumn style={styles.nameCol}>{strings.Action_By_Name}</TableHeaderColumn>
						</TableRow>
					</TableHeader>
					<TableBody displayRowCheckbox={false}>
						{props.warningData.WarningItems.map((item, index) =>
							<TableRow key={index}>
								<TableRowColumn style={styles.nameCol} title={item.Name}>{item.Name}</TableRowColumn>
								<TableRowColumn style={styles.idCol} title={item.ExternalId}>{item.ExternalId}</TableRowColumn>
								{props.warningData.Type === ETimecardSequenceActionType.GetPayroll &&
									<TableRowColumn>{timeHelper.getDateRangeListStr(timecardHelper.getTimecardDateRangeList(item.LockDates, props.selectedPaySettings))}</TableRowColumn>
								}
								<TableRowColumn style={styles.statusCol}>{strings.Change_In_Progress}</TableRowColumn>
								<TableRowColumn style={styles.nameCol}>{item.ActionByName}</TableRowColumn>
							</TableRow>
						)}
					</TableBody>
				</Table>
			}
		</Dialog >
	)
}

export default TimecardSequenceWarningDialog

const styles = {
	nameCol: {
		paddingLeft: 5,
		paddingRight: 5,
		width: 100
	},
	idCol: {
		paddingLeft: 5,
		paddingRight: 5,
		width: 75
	},
	statusCol: {
		paddingLeft: 5,
		paddingRight: 5,
		width: 125
	},
}